import React, { useEffect, useState } from 'react';

export default function GenerationProgress({ 
  durationSeconds = 60, 
  status, 
  label 
}) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    // Reset progress when duration changes significantly or component remounts
    setProgress(0);
    
    const intervalMs = 100;
    const steps = (durationSeconds * 1000) / intervalMs;
    const increment = 90 / steps; // Target 90% completion over the duration

    const timer = setInterval(() => {
      setProgress(prev => {
        // Stall at 90-99% if not complete
        if (prev >= 99) return 99;
        if (prev >= 90) return prev + 0.05; // Very slow crawl at the end
        return prev + increment;
      });
    }, intervalMs);

    return () => clearInterval(timer);
  }, [durationSeconds]);

  return (
    <div className="w-full max-w-lg mx-auto text-center p-6">
      <div className="mb-4">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <h3 className="text-xl font-bold text-gray-800 mb-1">{status}</h3>
        <p className="text-gray-500 text-sm">{label}</p>
      </div>
      
      <div className="w-full bg-gray-200 rounded-full h-2.5 mb-2 overflow-hidden">
        <div 
          className="bg-blue-600 h-2.5 rounded-full transition-all duration-100 ease-linear" 
          style={{ width: `${progress}%` }}
        ></div>
      </div>
      <div className="text-xs text-gray-400 text-right">{Math.round(progress)}%</div>
    </div>
  );
}
